import { gql } from 'graphql-request';
import { useMutation } from 'react-query';
import { graphqlConfig } from 'services/config/graphqlConfig';

export const usePostCoursePlan = () => {
  const { client } = graphqlConfig();
  const Mutation = useMutation(async ({ userId, courseId, planId }: { userId: number, courseId?: number, planId: number }) => client.request(
    gql`
    mutation CoursePlan($planId: Float!, $courseId: Float!, $userId: Float!) {
      coursePlan(plan_id: $planId, course_id: $courseId, userId: $userId) {
        message
      }
    }
    `,
    {
      planId,
      courseId,
      userId
    }
  ));
  return Mutation;
};
